import React, {Component, createRef} from 'react';
import inGame from '../../../Resources/ingame.png'
import './pScene3.css';
import MaxButton from "../../MaxButton";
import {FormattedMessage} from "react-intl";
import {getSpan, getTopWidth} from "../../../Utilities/utils";
import BgGrid from "../../BgGrid";

class PScene3 extends Component<> {
    constructor(props) {
        super(props);
        this.underlined = createRef();
        this.state = {
            line: {top: 0, width: 0},
        }
    }

    componentDidMount() {
        this.setState({
            line: getTopWidth(this.underlined, true, '90vw')
        });
    }

    render() {
        return (
        <section id={'ps3'} className={"p-container"}>
            <div id="pscene3" className={'content'}>
                <div id={'s3u1'} style={this.state.line} className={'underline purple accessibility-line'}/>
                <BgGrid className={'p-bg-grid'} id='p-bg3'
                        hLines={5} vLines={4} />
                <div  className={'p-text-container-scene-3'}>
                    <h2 id={'ps3txt'} className={"p-text-category"}><FormattedMessage id={"home_IGA_title"}/></h2>
                    <div id={'p3p-text-container'}>
                        <h1 className={"p-text"}>
                            {getSpan(["home_IGA_txt", "home_IGA_txt_2", "home_IGA_txt_3"],
                                "p_s3-txt", <span> </span>)}
                            <span ref={this.underlined} className={'p-text'}>
                            <FormattedMessage id={"home_IGA_txt_4"}/>
                        </span>
                            <span className={'p-text'}><FormattedMessage id={"home_IGA_txt_5"}/></span>
                        </h1>
                    </div>

                    <div className={"p-text left"}>
                        <MaxButton id={'ps3b'} width={'42vw'} clickRoute={'services'} service={"0"}>
                            home_learn_more_button
                        </MaxButton>
                    </div>
                </div>
                <br/>
                <div className={'p_in-game-container'}>
                    <img src={inGame} className={'p_in-game accessibility-img'} alt={"InGame"}/>
                </div>
            </div>
        </section>)
    }
}

export default PScene3;
